/*
 * Event pop-up (sections/event-popup.liquid).
 *
 * Rules:
 *  - shows once per visit (session), on whichever page the visitor lands on
 *  - once it has been closed it stays closed for that campaign (localStorage)
 *  - never shows after the end date (New Zealand time)
 *  - the image is only downloaded when the pop-up is actually going to show
 *  - in the theme editor it always shows, so changes can be previewed
 *
 * Changing the section's "Campaign ID" makes it show again for everyone.
 */
(function () {
  'use strict';

  var dialog = document.getElementById('event-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var key = 'salo2go:event-popup:' + (dialog.getAttribute('data-campaign') || 'event');
  var designMode = dialog.getAttribute('data-design-mode') === 'true';

  // Storage can throw (private browsing, blocked cookies) -- treat that as "nothing stored".
  function read(store, name) {
    try { return store.getItem(name); } catch (e) { return null; }
  }
  function write(store, name, value) {
    try { store.setItem(name, value); } catch (e) { /* ignore */ }
  }

  // Today's date in New Zealand as YYYY-MM-DD ("en-CA" formats dates that way).
  function todayInNZ() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return null;
    }
  }

  if (!designMode) {
    var end = (dialog.getAttribute('data-end-date') || '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(end)) {
      var today = todayInNZ();
      if (today && today > end) return;               // the event is over
    }
    if (read(window.localStorage, key) === 'dismissed') return;   // closed it before
    if (read(window.sessionStorage, key) === 'shown') return;     // already shown this visit
  }

  var img = dialog.querySelector('img[data-src]');
  if (!img) return;

  var delay = parseInt(dialog.getAttribute('data-delay'), 10);
  if (isNaN(delay) || delay < 0) delay = 0;

  function lockScroll(on) {
    document.documentElement.classList.toggle('has-popup', on);
  }

  function open() {
    if (dialog.open) return;
    write(window.sessionStorage, key, 'shown');
    lockScroll(true);
    dialog.showModal();
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  // "close" fires for the X button, Escape and a backdrop click alike.
  dialog.addEventListener('close', function () {
    lockScroll(false);
    if (!designMode) write(window.localStorage, key, 'dismissed');
  });

  var closeBtn = dialog.querySelector('[data-event-popup-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // A click on the dimmed area outside the card is reported with the dialog itself as the target.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) close();
  });

  // Wait for the image *and* the delay, so the pop-up never opens half-empty.
  var imageReady = new Promise(function (resolve) {
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', function () { resolve(false); }, { once: true });
    img.src = img.getAttribute('data-src');
  });
  var delayDone = new Promise(function (resolve) { window.setTimeout(resolve, delay); });

  Promise.all([imageReady, delayDone]).then(function (results) {
    if (results[0] === false) return;      // image failed to load -- show nothing rather than a broken box
    open();
  });
})();
